import CurrentMySchedule from "./current-my-schedule";

const Offers: React.FC = () => {
  return (
    <div>
      <div className="mt-1">
        <h3 className="text-xl font-semibold text-[#111827]">
          Schedule Management
        </h3>
        <CurrentMySchedule />
      </div>
    </div>
  );
};

export default Offers;
